(() => {
  'use strict';

  if (document.getElementById('ssport-consent-backdrop')) return;

  const root = document.documentElement;
  const body = document.body;
  const inertElements = new Set();
  const backdrop = document.createElement('div');
  backdrop.id = 'ssport-consent-backdrop';
  backdrop.hidden = true;
  backdrop.setAttribute('aria-hidden', 'true');
  body.append(backdrop);

  let banner;
  let preferences;
  let active = false;
  let scheduled = false;
  let failed = false;
  let returnFocus;
  let originalModal;
  let stylesChecked = false;

  const visible = (element) => Boolean(element?.isConnected && element.getClientRects().length);
  const activePanel = () => visible(preferences) ? preferences : banner;
  const focusable = () => Array.from(activePanel().querySelectorAll('button, a[href], input'))
    .filter((element) => visible(element) && !element.disabled);
  const focusPanel = () => {
    if (visible(preferences)) {
      preferences.querySelector('#shopify-pc__prefs__header-close')?.focus({preventScroll: true});
    } else if (banner) {
      banner.setAttribute('tabindex', '-1');
      banner.focus({preventScroll: true});
    }
  };

  const release = () => {
    root.classList.remove('ssport-consent-locked');
    backdrop.hidden = true;
    inertElements.forEach((element) => { element.inert = false; });
    inertElements.clear();
    if (banner) {
      if (originalModal === null) banner.removeAttribute('aria-modal');
      else if (originalModal !== undefined) banner.setAttribute('aria-modal', originalModal);
    }
    if (active && returnFocus?.isConnected && !banner?.contains(returnFocus)
      && !preferences?.contains(returnFocus)) returnFocus.focus({preventScroll: true});
    active = false;
  };

  const failOpen = (reason) => {
    failed = true;
    observer.disconnect();
    appearanceObserver.disconnect();
    release();
    banner?.classList.remove('ssport-consent-enhanced');
    backdrop.remove();
    console.warn('[S-Sport consent] Native banner fallback:', reason);
  };

  const sync = () => {
    scheduled = false;
    if (failed) return;
    try {
      const nextBanner = document.getElementById('shopify-pc__banner');
      const nextPreferences = document.getElementById('shopify-pc__prefs');
      if (nextBanner !== banner || nextPreferences !== preferences) {
        appearanceObserver.disconnect();
        if (nextBanner !== banner) {
          release();
          banner = nextBanner;
          originalModal = banner?.getAttribute('aria-modal');
        }
        preferences = nextPreferences;
        [banner, preferences].filter(Boolean).forEach((element) => {
          appearanceObserver.observe(element, {attributes: true, attributeFilter: ['style', 'hidden']});
        });
      }
      if (!banner) {
        if (active) release();
        return;
      }
      if (!stylesChecked) {
        if (getComputedStyle(backdrop).position !== 'fixed') return failOpen('Stylesheet unavailable');
        stylesChecked = true;
      }
      if (!banner.querySelector('#shopify-pc__banner__btn-accept')
        || !banner.querySelector('#shopify-pc__banner__btn-manage-prefs')) return failOpen('Native controls unavailable');

      if (!banner.classList.contains('ssport-consent-enhanced')) {
        banner.classList.add('ssport-consent-enhanced');
      }
      const preferencesVisible = visible(preferences);
      const bannerVisible = visible(banner);
      if (!bannerVisible && !preferencesVisible) return release();

      if (!active) returnFocus = document.activeElement;
      active = true;
      root.classList.add('ssport-consent-locked');
      backdrop.hidden = preferencesVisible;
      for (const element of body.children) {
        if (element !== banner && element !== preferences && element !== backdrop
          && !element.matches('script, style, link, #PBarNextFrame, #PBarNextFrameWrapper') && !element.inert) {
          element.inert = true;
          inertElements.add(element);
        }
      }
      if (bannerVisible && !preferencesVisible) {
        banner.setAttribute('aria-modal', 'true');
      }
      if (!activePanel().contains(document.activeElement)) focusPanel();
    } catch (error) {
      failOpen(error.message);
    }
  };

  const schedule = () => {
    if (!scheduled && !failed) {
      scheduled = true;
      queueMicrotask(sync);
    }
  };
  const observer = new MutationObserver((records) => {
    const relevant = records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
      node.nodeType === 1 && (node.id === 'shopify-pc__banner' || node.id === 'shopify-pc__prefs'
        || (active && !node.matches('script, style, link, #PBarNextFrame, #PBarNextFrameWrapper')))
    ));
    if (relevant) schedule();
  });
  const appearanceObserver = new MutationObserver(schedule);
  observer.observe(body, {childList: true});
  document.addEventListener('keydown', (event) => {
    if (!active || (!visible(banner) && !visible(preferences))) return;
    if (event.key === 'Tab') {
      const elements = focusable();
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }
  });
  document.addEventListener('focusin', () => {
    if (active && activePanel() && !activePanel().contains(document.activeElement)
      && !document.activeElement?.matches('#PBarNextFrame')) {
      focusPanel();
    }
  });
  sync();
})();
